import { render, staticRenderFns } from "./SiteTypesDetails.vue?vue&type=template&id=c4574982&scoped=true&"
import script from "./SiteTypesDetails.vue?vue&type=script&lang=js&"
export * from "./SiteTypesDetails.vue?vue&type=script&lang=js&"
import style0 from "./SiteTypesDetails.vue?vue&type=style&index=0&id=c4574982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4574982",
  null
  
)

component.options.__file = "SiteTypesDetails.vue"
export default component.exports